// Button.js
import React from 'react';
import SquareButton from './SquareButton';

const FilterButton = ({ onClick }) => {
  return <SquareButton color="blue" iconName="user" text="Filter" onClick={onClick} />
};

export default FilterButton;
